<template>
    <v-container fluid class="py-0 px-0" ref="container">
        <v-tabs
            ref="tabs"
            active-class="white"
            background-color="grey lighten-3"
            hide-slider
            class="py-0 my-0"
        >
            <v-tab
                :to="{
                    name: 'unnasigned-work-orders',
                }"
            >
                UNASSIGNED WORK ORDERS
            </v-tab>
            <v-tab
                :to="{
                    name: 'upcoming-events',
                }"
            >
                UPCOMING EVENTS
            </v-tab>
            <v-tab
                :to="{
                    name: 'shipment-calendar',
                }"
            >
                CALENDAR
            </v-tab>
        </v-tabs>
        <v-card flat class="py-0 my-0">
            <v-card-text
                class="overflow-y-auto px-4 pt-4"
                :style="{ height: `${height}px` }"
            >
                <router-view
                    ref="routerView"
                    @month-closed="handleMonthClosed"
                    @show-success="showSuccessMessage"
                />
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: 'ShipmentPlanner',
    data: () => ({
        loading: true,
        height: 0,
        companyId: JSON.parse(localStorage.getItem('company')),
    }),
    async mounted() {
        this.onResize()
    },
    methods: {
        onResize() {
            const {
                container: { clientHeight: containerHeight },
                tabs: {
                    $el: { clientHeight: tabsHeight },
                },
            } = this.$refs
            this.height = window.innerHeight - containerHeight - tabsHeight - 25
        },

        async handleMonthClosed() {
            // Refresh data in child components
            if (
                this.$refs.routerView &&
                this.$refs.routerView.$children.length > 0
            ) {
                const childComponent = this.$refs.routerView.$children[0]
                if (childComponent.refreshData) {
                    await childComponent.refreshData()
                }
            }
        },

        showSuccessMessage(message) {
            // You can implement a toast notification here
            console.log('Success:', message)
        },
    },
}
</script>

<style>
.v-data-table {
    border: 1px solid #eeeeee;
}
thead {
    background: #eeeeee;
}
</style>
